export default class TargetGroup {
  identifier
  condition
  constructor(identifier, condition) {
    this.identifier = identifier;
    this.condition = condition;
  }
}
